import * as React from "react";
import Box from '@mui/material/Box';
import Tab from '@mui/material/Tab';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';
import { useState } from 'react';
import { useTheme } from "@mui/material";
import { tokens } from "../../theme";
import EffDashboard from "../pages/EfficiencyDB";
import TableSupply from "../components/TableSupply";
import TableWarranty from "../components/TableWarranty";
import TableRejection from "../components/TableRejection";
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import DataTable  from '../components/TableUpload';


const MaintenanceHome = () => {
  const { tabIndex } = useParams();
  

    const theme = useTheme();
    const colors = tokens(theme.palette.mode);
    const user = useSelector((state) => state.user);
    const [isAdmin, setIsAdmin] = useState(user?.role === 'Maintenance Admin' ? true : false);

  
    const [selectedTab, setSelectedTab] = useState('1');
  
    const handleChange = (event, newValue) => {
      setSelectedTab(newValue);
    };

    const location = useLocation();
    let navigate = useNavigate();
    React.useEffect( () => {
      if(location.key === undefined || location.key === null || location.key === 'default'){
        navigate("/");   
      }
    }, [ location ] );


    React.useEffect( () => {
      if ( 1 == tabIndex || 2 == tabIndex || 3 == tabIndex || 4 == tabIndex || 5 == tabIndex ) {
        setSelectedTab( tabIndex);    
      }
  }, [ tabIndex ] );

  return (
    <TabContext value={selectedTab}>
    <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
      <TabList sx={{paddingLeft:"200px", paddingTop:"60px"}} TabIndicatorProps={{style: {backgroundColor: "#4863A0"}}}   onChange={handleChange}>
        <Tab label="Dashboard" value="1" />
        <Tab label="Supply" value="2" />
        <Tab label="Warranty" value="3" />
        <Tab label="Warranty %" value="4" />
        <Tab label="Complaints" value="5" />
      </TabList>
    </Box>
    <TabPanel value="1" sx={{ p: 0 }}><EffDashboard/></TabPanel>
    <TabPanel value="2"><TableSupply/></TabPanel>
    <TabPanel value="3"><TableWarranty/></TabPanel>
    <TabPanel value="4"><TableRejection/></TabPanel>
    <TabPanel value="5"><DataTable/></TabPanel>
  </TabContext> 
  )
}

export default MaintenanceHome